import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { CHANGE_TAB } from "../../constants/actionTypes";
import { profileUpdateService } from "../../Network/services/profileUpdateService";
import { validateKeyInput } from "../../utils/commonFunction";

import { useLocation, useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import Files from "react-files";
import { LoadingOverlay, Loader } from "react-overlay-loader";
import { ToastContainer, toast } from "react-toastify";
import TagsInput from "react-tagsinput";
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import "react-tagsinput/react-tagsinput.css";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-dropdown-select";
const mapStateToProps = (state) => ({
  ...state.articleList,
});

const mapDispatchToProps = (dispatch) => ({
});
function useForceUpdate() {
  const [value, setValue] = useState(0); // integer state
  return () => setValue((value) => value + 1); // update the state to force render
}
const ExperienceEditView = (props) => {
  let location = useLocation();
  let history = useHistory();
  const forceUpdate = useForceUpdate();

  const [isYes, setIsYes] = useState(true);

  const [experienceView, setExperienceView] = useState([]);
  const [expyear, setExpyear] = useState([]);
  const [expcompany, setExpcompany] = useState([]);
  const [expfrom, setExpfrom] = useState([]);
  const [expto, setExpto] = useState([]);
  const [expyear1, setExpyear1] = useState("");
  const [expcompany1, setExpcompany1] = useState("");
  const [expfrom1, setExpfrom1] = useState(null);
  const [expto1, setExpto1] = useState(null);
  const [readforproject, setReadforproject] = useState(null);
  const [projectrate, setProjectrate] = useState("");
  const [projectratetype, setProjectratetype] = useState("Hourly Rate");
  const [toyearValidation, setToyearValidation] = useState("");
  const [fromyearValidation, setFromyearValidation] = useState("");
  const [companyValidation, setCompanyValidation] = useState("");
  const [totalyearValidation, setTotalyearValidation] = useState("");
  const [projectrateValidation, setProjectrateValidation] = useState("");
  const [conditions, setAdditionalConditions] = useState("");
  const [dateRangeValidation, setDateRangeValidation] = useState({});
  const [lastChangedDate, setLastChangedDate] = useState(null); // Track which date was changed last: 'from' or 'to'

  const [pickerValue, setPickerValue] = useState(-1);
  const [isFrom, setIsFrom] = useState(true);

  const [isDatePickerVisible, setDatePickerVisibility] = useState(false);
  const [loading, setLoading] = useState(false);

  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [name, setName] = useState("");

  useEffect(() => {
    
    let user = JSON.parse(window.localStorage.getItem("UserData"));
    setName(user.first_name + " " + user.last_name);
    setFirstname(user.first_name);
    setLastname(user.last_name);
    setName(user.first_name + " " + user.last_name);
    setExpyear1(user.total_experience);
    setExpfrom1(
      user.working_from_date.split(",")[0] == ""
        ? null
        : moment(user.working_from_date.split(",")[0], "MM-DD-yyyy").toDate()
    );
    setExpto1(
      user.working_to_date.split(",")[0] == ""
        ? null
        : moment(user.working_to_date.split(",")[0], "MM-DD-yyyy").toDate()
    );
    setExpcompany1(user.working_company_name.split(",")[0]);
    setExpcompany(user.working_company_name.split(",").slice(1));
    setExperienceView(user.working_company_name.split(",").slice(1));
    const setexpfromNew = user.working_from_date
      .split(",")
      .slice(1)
      .map((answer) => {
        return moment(answer, "MM-DD-yyyy").toDate();
      });
    const setexptoNew = user.working_to_date
      .split(",")
      .slice(1)
      .map((answer) => {
        return moment(answer, "MM-DD-yyyy").toDate();
      });
    setExpfrom(setexpfromNew);
    setExpto(setexptoNew);
    setProjectrate(user.project_rate);
    setProjectratetype(user.project_rate_type);
    setAdditionalConditions(user.additional_condition);

    if(user.ready_for_project=="No"){
      setIsYes("");
    }
    
    
    let readyForProject = "";
    if(user.ready_for_project != "No" && user.ready_for_project != ""){

      readyForProject = moment(user.ready_for_project, "MM-DD-yyyy").toDate()
    }
    setReadforproject(readyForProject);

  }, []);

  useEffect(() => {
    if (expfrom1 && expto1) {
      const fromMoment = moment(expfrom1);
      const toMoment = moment(expto1);
      
      if (fromMoment.isValid() && toMoment.isValid()) {
        const fromDate = fromMoment.startOf('day');
        const toDate = toMoment.startOf('day');
        setDateRangeValidation((prevValidation) => {
          const newValidation = { ...prevValidation };
          if (fromDate.isAfter(toDate)) {
            if (lastChangedDate === 'to') {
              newValidation.mainTo = "To date cannot be before From date";
              delete newValidation.mainFrom;
            } else {
              newValidation.mainFrom = "From date cannot be after To date";
              delete newValidation.mainTo;
            }
          } else {
            delete newValidation.mainFrom;
            delete newValidation.mainTo;
          }
          return newValidation;
        });
      }
    } else {
      setDateRangeValidation((prevValidation) => {
        const newValidation = { ...prevValidation };
        delete newValidation.mainFrom;
        delete newValidation.mainTo;
        return newValidation;
      });
    }
  }, [expfrom1, expto1, lastChangedDate]);

  let back = (e) => {
    e.preventDefault();
    history.goBack();
  };

  const resetValidation = () => {
    setTotalyearValidation("");
    setCompanyValidation("");
    setFromyearValidation("");
    setToyearValidation("");
    setProjectrateValidation("");
  };
  expfrom.map((item) => {

  });


  const profileupdate = () => {
    resetValidation();
    if (expyear1 == "") {
      setTotalyearValidation("Please enter Total year");
      toast.success("Please enter Total year", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });

      return;
    }
    if (expcompany1 == "") {
      setCompanyValidation("Please enter Company Name");
      toast.success("Please enter Company Name", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }

    if (!expfrom1) {
      setFromyearValidation("Please enter From year");
      toast.error("Please enter From year", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }

    if (!expto1) {
      setToyearValidation("Please enter To year");
      toast.error("Please enter To year", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }

    const fromMoment = moment(expfrom1);
    const toMoment = moment(expto1);
    
    if (!fromMoment.isValid() || !toMoment.isValid()) {
      toast.error("Please enter valid dates", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }

    const fromDateNormalized = fromMoment.clone().startOf('day');
    const toDateNormalized = toMoment.clone().startOf('day');
    
    const momentComparison = fromDateNormalized.isAfter(toDateNormalized);
    const nativeComparison = fromDateNormalized.toDate().getTime() > toDateNormalized.toDate().getTime();
    
    if (momentComparison || nativeComparison) {
      setDateRangeValidation((prev) => ({
        ...prev,
        mainFrom: "From date cannot be after To date"
      }));
      toast.error("From date cannot be after To date. Please correct the dates before submitting.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }

    let hasValidationError = false;
    let validationErrors = {};
    
    expfrom.forEach((fromDate, index) => {
      if (fromDate && expto[index]) {
        const fromMoment = moment(fromDate);
        const toMoment = moment(expto[index]);
        
        if (fromMoment.isValid() && toMoment.isValid()) {
          const from = fromMoment.startOf('day');
          const to = toMoment.startOf('day');
          if (from.isAfter(to)) {
            validationErrors[index] = "From date cannot be after To date";
            hasValidationError = true;
          }
        }
      }
    });
    
    if (hasValidationError) {
      setDateRangeValidation((prev) => ({
        ...prev,
        ...validationErrors
      }));
      toast.error("Please fix date range errors in additional experiences before submitting", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }

    const finalCheckFrom = moment(expfrom1).startOf('day');
    const finalCheckTo = moment(expto1).startOf('day');
    if (finalCheckFrom.isAfter(finalCheckTo)) {
      toast.error("Invalid date range: From date cannot be after To date.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }
    if (projectrate == "") {
      setProjectrateValidation("Please enter projectrate amount");
      toast.success("Please enter projectrate amount", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }

    const expfromNew = expfrom.map((answer) => {
      return moment(answer).format("MM-DD-yyyy");
    });
    const exptoNew = expto.map((answer) => {
      return moment(answer).format("MM-DD-yyyy");
    });


    let expcompanyString = "";
    let expyearString = "";
    let expfromString = "";
    let exptoString = "";

    if (expcompany.length > 0) {

      expcompanyString = expcompany1 + "," + expcompany.join(",");
      expyearString = expyear1;
      expfromString =
        moment(expfrom1).format("MM-DD-yyyy") + "," + expfromNew.join(",");
      exptoString =
        moment(new Date(expto1)).format("MM-DD-yyyy") +
        "," +
        exptoNew.join(",");
    } else {

      expcompanyString = expcompany1;
      expyearString = expyear1;
      expfromString = moment(new Date(expfrom1)).format("MM-DD-yyyy");
      exptoString = moment(new Date(expto1)).format("MM-DD-yyyy");
    }


    const FormData = require("form-data");

    const form = new FormData();
    setLoading(true);

    form.append("total_experience[]", expyearString);
    form.append("working_company_name[]", expcompanyString);
    form.append("working_from_date[]", expfromString);
    form.append("working_to_date[]", exptoString);

    let ready_for_project_date = "No";
    if(isYes){
      if(readforproject!="" && readforproject!=null){
        ready_for_project_date = moment(readforproject).format("MM-DD-yyyy");
      }
    }
    form.append( "ready_for_project", ready_for_project_date );
    form.append("project_rate", projectrate);
    form.append("project_rate_type", projectratetype);
    form.append("additional_condition", conditions);





    profileUpdateService
      .profileUpdatecall(form)
      .then(async (res) => {
        if (res.status == 200) {
          window.localStorage.setItem("UserData", JSON.stringify(res.data[0]));
          window.localStorage.setItem("auth_token", res.data[0].auth_token);
          toast.success(res.message, {
            position: "top-right",
            type: "success",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
          history.goBack();
        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success("Something went wrong! please try again later!!", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const redirect = () => {
    history.push("/referenceUpdate");
  };
  const addexp = (index) => {
    resetValidation();
    if (expyear1 == "") {
      setTotalyearValidation("Please enter Total year");
      return;
    }
    if (expcompany1 == "") {
      setCompanyValidation("Please enter Company Name");
      return;
    }

    if (expfrom1 == "") {
      setFromyearValidation("Please enter From year");
      return;
    }

    if (expto1 == "") {
      setToyearValidation("Please enter To year");
      return;
    }

    setExperienceView([...experienceView, { id: index }]);
  };
  const addexpcompany = (index, text) => {



    expcompany[index] = text;
    setExpcompany(expcompany);

  };
  const addexpfrom = (index, text) => {
    expfrom[index] = text;
    setExpfrom(expfrom);
    
    // Validate date range
    if (text && expto[index]) {
      const fromMoment = moment(text).startOf('day');
      const toMoment = moment(expto[index]).startOf('day');
      if (fromMoment.isAfter(toMoment)) {
        // From date is after To date - show error in From field
        setDateRangeValidation({
          ...dateRangeValidation,
          [`${index}From`]: "From date cannot be after To date"
        });
        delete dateRangeValidation[`${index}To`];
      } else {
        const newValidation = { ...dateRangeValidation };
        delete newValidation[`${index}From`];
        delete newValidation[`${index}To`];
        setDateRangeValidation(newValidation);
      }
    } else {
      const newValidation = { ...dateRangeValidation };
      delete newValidation[`${index}From`];
      delete newValidation[`${index}To`];
      setDateRangeValidation(newValidation);
    }
    
    forceUpdate();
  };
  const addexpto = (index, text) => {
    expto[index] = text;
    setExpto(expto);
    
    // Validate date range
    if (text && expfrom[index]) {
      const fromMoment = moment(expfrom[index]).startOf('day');
      const toMoment = moment(text).startOf('day');
      if (toMoment.isBefore(fromMoment)) {
        // To date is before From date - show error in To field
        setDateRangeValidation({
          ...dateRangeValidation,
          [`${index}To`]: "To date cannot be before From date"
        });
        delete dateRangeValidation[`${index}From`];
      } else {
        const newValidation = { ...dateRangeValidation };
        delete newValidation[`${index}From`];
        delete newValidation[`${index}To`];
        setDateRangeValidation(newValidation);
      }
    } else {
      const newValidation = { ...dateRangeValidation };
      delete newValidation[`${index}From`];
      delete newValidation[`${index}To`];
      setDateRangeValidation(newValidation);
    }
    
    forceUpdate();
  };

  const removeExp = (value, index) => {
    setExperienceView(
      experienceView.filter((item, index1) => index1 !== index)
    );
    setExpcompany(expcompany.filter((item, index1) => index1 !== index));
    setExpfrom(expfrom.filter((item, index1) => index1 !== index));
    setExpto(expto.filter((item, index1) => index1 !== index));
    
    // Clear all validation errors and revalidate remaining entries
    const newValidation = {};
    const filteredFrom = expfrom.filter((item, index1) => index1 !== index);
    const filteredTo = expto.filter((item, index1) => index1 !== index);
    
    filteredFrom.forEach((fromDate, newIndex) => {
      if (fromDate && filteredTo[newIndex]) {
        if (moment(fromDate).isAfter(moment(filteredTo[newIndex]))) {
          newValidation[newIndex] = "From date cannot be after To date";
        }
      }
    });
    
    filteredTo.forEach((toDate, newIndex) => {
      if (toDate && filteredFrom[newIndex]) {
        if (moment(toDate).isBefore(moment(filteredFrom[newIndex]))) {
          newValidation[newIndex] = "To date cannot be before From date";
        }
      }
    });
    
    setDateRangeValidation(newValidation);
  };

  return (
    <LoadingOverlay>
      <section className="explore explore1">
      <div className="container">
        <div className="banner">
          <div className="row">
            <div className="col-md-4">
              <div className="breadcrumps">
                <ul>
                  <li>
                    <a href="#!" onClick={(e) => back(e)}>
                      <i className="bx bx-chevron-left" /> Back to Profile
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4"></div>
          </div>
        </div>
        <section className="onbord-section">
        <div className="row">
          <div className="col-md-12 text-center">
            <h1 className="title">{name}, tell us a bit more about yourself</h1>
            <p className="subtitle">GigFWS needs the below information to help you better.</p>
          </div>
        </div>
          <div className="row">
            <div className="col-md-12">
              <div className="board-box board-box1">
                <div className="one">
                  <div className="row">
                    <div className="col-md-12">
                    <p>Tell us about your Experience</p>
                      <div className="form-group">
                        <label>Total Experience</label>
                        <input
                          type="text"
                          name
                          className="form-control"
                          required="required"
                          placeholder="Total Experience"
                          value={expyear1}
                          onChange={(e) => {
                            let value = e.target.value;
                            value = value.replace(/[^0-9.]/g, '');
                            const parts = value.split('.');
                            if (parts.length > 2) {
                              value = parts[0] + '.' + parts.slice(1).join('');
                            }

                            const beforeDecimal = parts[0] || '';
                            let afterDecimal = parts[1] || '';

                            if (beforeDecimal.length > 2) {
                              value = beforeDecimal.substring(0, 2) + (afterDecimal ? '.' + afterDecimal : '');
                            }

                            if (afterDecimal) {
                              if (afterDecimal.length > 2) {
                                afterDecimal = afterDecimal.substring(0, 2);
                              }
                              const afterDecimalValue = parseInt(afterDecimal, 10);
                              if (afterDecimalValue > 11) {
                                afterDecimal = '11';
                              }
                              const beforePart = value.split('.')[0];
                              value = beforePart + '.' + afterDecimal;
                            }

                            setExpyear1(value);
                          }}
                          onKeyDown={(e) => {
                            validateKeyInput(e, /^[0-9.]$/);

                            if (e.key === '.' && expyear1 && expyear1.includes('.')) {
                              e.preventDefault();
                            }
                          }}
                          onPaste={(e) => {
                            e.preventDefault();
                            const pastedText = (e.clipboardData || window.clipboardData).getData('text');
                            let value = pastedText.replace(/[^0-9.]/g, '');

                            const parts = value.split('.');
                            if (parts.length > 2) {
                              value = parts[0] + '.' + parts.slice(1).join('');
                            }

                            const beforeDecimal = parts[0] || '';
                            let afterDecimal = parts[1] || '';

                            if (beforeDecimal.length > 2) {
                              value = beforeDecimal.substring(0, 2) + (afterDecimal ? '.' + afterDecimal : '');
                            }

                            if (afterDecimal) {
                              if (afterDecimal.length > 2) {
                                afterDecimal = afterDecimal.substring(0, 2);
                              }
                              const afterDecimalValue = parseInt(afterDecimal, 10);
                              if (afterDecimalValue > 11) {
                                afterDecimal = '11';
                              }
                              const beforePart = value.split('.')[0];
                              value = beforePart + '.' + afterDecimal;
                            }

                            setExpyear1(value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Company</label>
                        <input
                          type="text"
                          name
                          className="form-control"
                          required="required"
                          placeholder="Company"
                          value={expcompany1}
                          onChange={(e) => {
                            setExpcompany1(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>From</label>

                        <DatePicker
                          dateFormat="MM-dd-yyyy"
                          className="form-control"
                          selected={expfrom1}
                          onChange={(date) => {
                            setLastChangedDate('from');
                            setExpfrom1(date);
                          }}
                          placeholderText="From"
                        />
                        {dateRangeValidation.mainFrom && (
                          <span style={{ color: "red", fontSize: "12px", display: "block", marginTop: "5px" }}>
                            {dateRangeValidation.mainFrom}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>To</label>
                        <DatePicker
                          dateFormat="MM-dd-yyyy"
                          className="form-control"
                          selected={expto1}
                          onChange={(date) => {
                            setLastChangedDate('to');
                            setExpto1(date);
                          }}
                          placeholderText="To"
                        />
                        {dateRangeValidation.mainTo && (
                          <span style={{ color: "red", fontSize: "12px", display: "block", marginTop: "5px" }}>
                            {dateRangeValidation.mainTo}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <button className="btn btn-sm btn-warning" onClick={() => addexp(experienceView.length)}>
                      Add Experience
                    </button>
                  </div>
                </div>
                <hr />

                {experienceView.map((value, index) => (
                  <div>
                    <div className="two">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              name
                              className="form-control"
                              required="required"
                              placeholder="Company"
                              value={expcompany[index]}
                              onChange={(e) => {
                                addexpcompany(index, e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <DatePicker
                              dateFormat="MM-dd-yyyy"
                              className="form-control"
                              selected={
                                typeof expfrom[index] != "undefined"
                                  ? expfrom[index]
                                  : null
                              }
                              onChange={(date) => addexpfrom(index, date)}
                              placeholderText="From"
                            />
                            {dateRangeValidation[`${index}From`] && (
                              <span style={{ color: "red", fontSize: "12px", display: "block", marginTop: "5px" }}>
                                {dateRangeValidation[`${index}From`]}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <DatePicker
                              dateFormat="MM-dd-yyyy"
                              className="form-control"
                              selected={
                                typeof expto[index] != "undefined"
                                  ? moment(expto[index], "MM-dd-yyyy").toDate()
                                  : null
                              }
                              onChange={(date) => addexpto(index, date)}
                              placeholderText="To"
                            />
                            {dateRangeValidation[`${index}To`] && (
                              <span style={{ color: "red", fontSize: "12px", display: "block", marginTop: "5px" }}>
                                {dateRangeValidation[`${index}To`]}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <button className="btn btn-sm btn-danger" onClick={() => removeExp(value, index)}>
                        Remove Experience
                      </button>
                    </div>
                    <hr />
                  </div>
                ))}
                <div className="three">
                  <div className="row">
                    <div className="col-md-12">
                      <p>Ready for Projects?</p>
                    </div>
                    <div className="col-md-12">
                      <button
                        className={`btn ${isYes ? "yes" : null}`}
                        onClick={() => setIsYes(true)}
                      >
                        Yes
                      </button>
                      <button
                        className={`btn ${isYes ? null : "yes"}`}
                        onClick={() => setIsYes(false)}
                      >
                        No
                      </button>
                    </div>
                    {isYes ? (
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>If yes,</label>
                          
                          
                          {readforproject ? (
                            <DatePicker
                              dateFormat="MM-dd-yyyy"
                              className="form-control"
                              selected={readforproject}
                              onChange={(date) => setReadforproject(date)}
                              placeholderText="When"
                            />
                          ):
                            <DatePicker
                              dateFormat="MM-dd-yyyy"
                              className="form-control"
                              onChange={(date) => setReadforproject(date)}
                              placeholderText="When"
                            />
                          }
                          
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
                <hr />
                <div className="four">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <p>Rate</p>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>₹ INR</label>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <input
                          type="text"
                          name
                          className="form-control"
                          required="required"
                          placeholder="Amount"
                          value={projectrate}
                          onChange={(e) => {
                            const value = e.target.value;
                            const numericValue = value.replace(/\D/g, '');
                            const limitedValue = numericValue.slice(0, 6);
                            setProjectrate(limitedValue);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <Select
                          className="form-control"
                          style={{ display: "flex" }}
                          options={[
                            {
                              label: "Hourly Rate",
                              value: "Hourly Rate",
                            },
                            {
                              label: "Day Rate",
                              value: "Day Rate",
                            },
                            { label: "Weekly Rate", value: "Weekly Rate" },
                            {
                              label: "Fixed Charges",
                              value: "Fixed Charges",
                            },
                          ]}
                          placeholder={projectratetype}
                          onChange={(values) => {
                            setProjectratetype(values[0].value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label className="textarea">Additional comments</label>
                        <textarea
                          name
                          className="form-control"
                          placeholder="Provide more details about the Job."
                          defaultValue={""}
                          value={conditions}
                          maxLength="500"
                          onChange={(e) => {
                            setAdditionalConditions(e.target.value);
                          }}
                        />
                        <div className="character-count">
                          {conditions ? conditions.length : 0} / 500
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 post-new-job">
                      <button onClick={profileupdate}>Submit</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
    <Loader loading={loading} />
    </LoadingOverlay>    
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ExperienceEditView);
